<template>
  <div>
    <div style="overflow-x: scroll; overflow-y: hidden">
      <div style="width: fit-content">
        <v-card elevation="0" class="rounded-lg primary--text" height="47">
          <div class="text-center d-flex align-center" style="height: 100%">
            <div class="text-start ps-6" style="width: 250px">
              {{ $t("course.courseDetails.module") }}
            </div>
            <div class="text-start" style="width: 350px">
              {{ $t("reports.quiz.quiz") }}
            </div>
            <div class="text-start" style="width: 250px">
              {{ $t("reports.employee") }}
            </div>
            <div style="width: 150px">
              {{ $t("reports.quiz.totalMark") }}
            </div>
            <div style="width: 150px">
              {{ $t("reports.quiz.passPercentage") }}
            </div>
            <div style="width: 150px">
              {{ $t("reports.quiz.score") }}
            </div>
            <div style="width: 150px">
              {{ $t("reports.quiz.totalAttempts") }}
            </div>
            <div style="width: 100px">
              {{ $t("reports.revenues.status") }}
            </div>
          </div>
        </v-card>
      </div>

      <div v-if="loading && !quizReports.length">
        <v-progress-circular indeterminate color="primary">
        </v-progress-circular>
      </div>
      <div v-else-if="!loading && quizReports.length">
        <div
          v-for="(quiz, index) in quizReports"
          :key="index"
          class="pt-5"
          style="width: fit-content"
        >
          <v-card elevation="0" class="rounded-lg textLight--text">
            <div
              class="text-center d-flex align-center"
              style="min-height: 65px"
            >
              <div class="text-start ps-6 text-ellipse-2" style="width: 250px">
                {{
                  quiz &&
                  quiz.trainingProgresses &&
                  quiz.trainingProgresses.trainingModuleContent &&
                  quiz.trainingProgresses.trainingModuleContent.trainingModule
                    ? getLocalisedValue(
                        quiz.trainingProgresses.trainingModuleContent
                          .trainingModule.title
                      )
                    : " - "
                }}
              </div>

              <div class="text-start text-ellipse-2" style="width: 350px">
                {{
                  quiz &&
                  quiz.trainingProgresses &&
                  quiz.trainingProgresses.trainingModuleContent
                    ? getTrainingModuleContentTitle(
                        quiz.trainingProgresses.trainingModuleContent
                      )
                    : " - "
                }}
              </div>

              <div class="text-start text-ellipse-2" style="width: 250px">
                {{
                  quiz &&
                  quiz.employee &&
                  quiz.employee.user &&
                  quiz.employee.user.firstName
                    ? `${quiz.employee.user.firstName || ""} ${
                        quiz.employee.user.lastName || ""
                      }`
                    : " - "
                }}
              </div>

              <div style="width: 150px">
                {{
                  quiz &&
                  quiz.trainingProgresses &&
                  quiz.trainingProgresses.quizAttempts &&
                  quiz.trainingProgresses.quizAttempts.totalMark
                    ? quiz.trainingProgresses.quizAttempts.totalMark
                    : " - "
                }}
              </div>

              <div style="width: 150px">
                {{
                  quiz &&
                  quiz.trainingProgresses &&
                  quiz.trainingProgresses.trainingModuleContent &&
                  quiz.trainingProgresses.trainingModuleContent.quizContent &&
                  quiz.trainingProgresses.trainingModuleContent.quizContent
                    .quiz &&
                  quiz.trainingProgresses.trainingModuleContent.quizContent.quiz
                    .passMark
                    ? quiz.trainingProgresses.trainingModuleContent.quizContent
                        .quiz.passMark + "%"
                    : " - "
                }}
              </div>

              <div style="width: 150px">
                {{
                  quiz &&
                  quiz.trainingProgresses &&
                  quiz.trainingProgresses.quizAttempts &&
                  quiz.trainingProgresses.quizAttempts.acquiredMark
                    ? quiz.trainingProgresses.quizAttempts.acquiredMark
                    : " - "
                }}
              </div>
              <div style="width: 150px">
                {{
                  quiz &&
                  quiz.trainingProgresses &&
                  quiz.trainingProgresses.totalAttempts
                    ? quiz.trainingProgresses.totalAttempts
                    : " - "
                }}
              </div>
              <div style="width: 100px">
                <div
                  v-if="
                    quiz &&
                    quiz.trainingProgresses &&
                    quiz.trainingProgresses.quizAttempts &&
                    quiz.trainingProgresses.quizAttempts.status
                  "
                >
                  <v-icon
                    size="25"
                    color="red"
                    v-if="
                      quiz.trainingProgresses.quizAttempts.status === 'FAILED'
                    "
                    >mdi-close-circle-outline</v-icon
                  >
                  <v-icon
                    size="25"
                    color="success"
                    v-else-if="
                      quiz.trainingProgresses.quizAttempts.status === 'PASSED'
                    "
                    >mdi-check-circle-outline</v-icon
                  >
                </div>
                <div v-else>-</div>
              </div>
            </div>
          </v-card>
        </div>
      </div>
      <div
        v-else-if="!loading && !quizReports.length"
        class="textLight--text font-weight-medium"
        align="center"
      >
        {{ $t("noItems") }}
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    quizReports: {
      type: Array,
      default: () => [],
    },
    loading: {
      default: true,
      type: Boolean,
    },
  },
};
</script>
